define ['./checkbox.css'], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./checkbox.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->

      scope.$watch("field.value", (newValue) ->
        if scope.field.required
          scope.update()
      , true)
      
      if scope.field.required
        scope.update = ->
          scope.required = !_.some scope.field.value, (val) ->
            val == true
        if scope.stage == 'edit'
          scope.update()
        else
          scope.required = true
      else
        scope.required = false
        scope.update = ->
          return

      if _.isString(scope.field.value)
        val = scope.field.value
        scope.field.value = {}
        scope.field.value[val] = true
      
      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label



// WEBPACK FOOTER //
// ./directives/freeforms/checkbox/checkbox.coffee